/* eslint-disable react/no-danger */
/* eslint-disable class-methods-use-this */
/* eslint-disable no-console */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-wrap-multilines */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable semi */
/* eslint-disable padded-blocks */
/* eslint-disable max-len */
/* eslint-disable no-multiple-empty-lines */
/* eslint-disable react/self-closing-comp */
/* eslint-disable object-curly-newline */
/* eslint-disable indent */
/* eslint-disable arrow-parens */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prefer-stateless-function */
import React from 'react'
import * as H from 'history'
import { ISupportSpinner } from '../shared/Ajax'
import AccountFetch from '../controllers/AccountFetch'
import { ExportReadinessModel } from '../models/ExportReadinessModel'

interface ExportReadinessFrameProps {
  history: H.History
  baseUrl: string
}

interface ExportReadinessFrameState {
    loading: boolean
    iframeShown: boolean
    topTextHtml: string

    personId: string
    ABN: string
    businessName: string
    firstName: string
    lastName: string
    email: string

    savingInProgress: boolean | undefined
}

/*
    //<iframe frameborder="0" height="465px" width="470px" scrolling="no"
    //src={this.props.baseUrl}
    NodeJS.Timeout
*/

type TimeoutType = ReturnType<typeof setTimeout>;

export default class ExportReadinessFrame extends React.Component<ExportReadinessFrameProps, ExportReadinessFrameState> implements ISupportSpinner {
    timerID: TimeoutType | null = null; // timerID = NodeJS.Timeout (in a server environment, but in Browser land it's just a number)
    accountAjax: AccountFetch
    completedAt: Date

    apiResult: boolean | null
    apiError: string | null

  constructor(props: ExportReadinessFrameProps) {
    super(props)

    this.accountAjax = new AccountFetch();

    this.state = {
      loading: true,
      iframeShown: true,
      topTextHtml: '',

      personId: '',
      ABN: '',
      businessName: '',
      firstName: '',
      lastName: '',
      email: '',

      savingInProgress: undefined,
    }
  }

  componentDidMount() {

    fetch('api/account/GetLoggedInUserInfo', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    })
    .then(response => {
        if (response.ok) {
            return response.json()
        }
        throw new Error('User info not found')
    })
    .then(data => {
        // ensure Number;
        let personId = Number(data.personId);
        if (Number.isNaN(personId)) {
            personId = -1;
        }
        this.setState({
            personId: data.personId,
            ABN: data.abn,
            businessName: data.businessName,
            firstName: data.firstname,
            lastName: data.lastname,
            email: data.email,
            loading: false,
        })
    })
    .catch(error => console.error('Error:', error))

      // handles messages from embedded page;
      window.addEventListener('message', this.embeddedPageMessageReceiver)

      // get context to display above iframe
      this.accountAjax.getExportReadinessText()
          .then(data => {
              this.setState({
                  topTextHtml: data.EXPORT_READY_PAGE_IntroText,
              });
          })
          .catch(error => console.error('Error:', error));


      // Start a timer while this page is mounted.
      this.timerID = setInterval(
          () => this.keepAlive(),
          15 * 60 * 1000, // call every 15 minutes
      );
  }

  componentWillUnmount() {
      window.removeEventListener('message', this.embeddedPageMessageReceiver);

      if (this.timerID) {
          clearInterval(this.timerID);
      }
  }

  formatABN = (abn: string) => {
    const abnStr = abn.toString()
    if (abnStr.length !== 11) {
        // throw new Error('ABN must be an 11 digit number');
        return abn // whatever was input.
    }
    return `${abnStr.slice(0, 2)} ${abnStr.slice(2, 5)} ${abnStr.slice(5, 8)} ${abnStr.slice(8)}`
  }

  keepAlive = () => {
    fetch('api/account/GetLoggedInUserInfo', {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    })
        .then(response => {
            if (!response.ok) {
                throw new Error('Keep alive check failed') // falls thru to catch block
            }
        })
        .catch(error => console.error('Error:', error))
  }

  embeddedPageMessageReceiver = (event: MessageEvent) => {
    console.log('Received message:', event.data);
    const data = JSON.parse(event.data);

    if (data.CompletedAt) {
        this.completedAt = data.CompletedAt; // set as a 'class property', not 'state property'
        // Call CRM API when 'CompletedAt' is received
        this.setState({ savingInProgress: true });
        this.notifyCrmApi(data.CompletedAt);
    } else if (data.Close) {
        // "Close" the iframe when 'Close' is received
        this.setState({ iframeShown: false });

        if (this.state.savingInProgress === false) { // cycles from undefined, to true, to false;
            this.closeIframe();
        } else {
            this.retryCloseIframe();
        }
    }
  }


    closeIframe = () => {
        // essentially nav away to landing page.
        this.props.history.push('/');
    }

    retryCloseIframe = () => {
        const retryInterval = setInterval(() => {
            if (this.state.savingInProgress === false) {
                clearInterval(retryInterval);
                this.closeIframe();
            } else {
                console.log('Retrying close...');
            }
        }, 3000); // Retry every 3 seconds
    }


    notifyCrmApi = (completedAt: Date) => {
        const exportReadinessDto = {
            PersonId: this.state.personId,
            Abn: this.state.ABN,
            CompletedAt: completedAt,
            ApiResult: null as (boolean | null),
            ApiError: null as (string | null), // initial value

            BusinessName: this.state.businessName,
            Firstname: this.state.firstName,
            Lastname: this.state.lastName,
            Email: this.state.email,
        };

        fetch('api/Account/SetExportReadinessInternalTraining', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(exportReadinessDto),
        })
            .then(response => response.json())
            .then(data => {
                // retrieve ApiResult, ApiError from Crm-Api-Call, and store as a class property
                console.log('CRM API success, DTO returned:', data)
                this.apiResult = data.apiResult;
                this.apiError = data.apiError;

                // Call saveTrainingRecordToAzureSQL after fetch request has succeeded
                this.saveTrainingRecordToAzureSQL().then(() => {
                    this.setState({
                        savingInProgress: false,
                    });
                });
            })
            .catch(error => {
                console.error('Error:', error);
                this.apiResult = false;
                this.apiError = 'CRM Api failed; manually set';

                // Call saveTrainingRecordToAzureSQL even if fetch request has failed
                this.saveTrainingRecordToAzureSQL().then(() => {
                    this.setState({
                        savingInProgress: false,
                    });
                });
            });
    }

  saveTrainingRecordToAzureSQL = async () => {

    try {
        // due to poor implementation of Export-Readiness site, CompletedAt message may fire multiple times;
        // we only want to log once, hence check if already logged before insert;

        const readiness = await this.accountAjax.getExportReadinessAsync(this.state.personId, this.state.ABN);
        if (readiness === null) {
            // Record not found, do insert;
            const dataObj: ExportReadinessModel = {
                personId: this.state.personId,
                abn: this.state.ABN,
                firstname: this.state.firstName,
                lastname: this.state.lastName,
                email: this.state.email,
                businessName: this.state.businessName,
                completedAt: this.completedAt,
                apiResult: this.apiResult,
                apiError: this.apiError,
            };
            const updatedReadiness = await this.accountAjax.addOrUpdateExportReadinessAsync(dataObj);
            console.log('inserted:', updatedReadiness);

        } else {
            console.log('found:', readiness);
        }
    } catch (error) {
        console.error('Error:', error);
    }
  }

  handleButtonClick = async () => { }

  // eslint-disable-next-line react/no-unused-class-component-methods
  toggleSpinner(on: boolean, callback: { (): any }): void {
    this.setState({ loading: on }, callback)
  }


  render() {
    const { firstName, lastName, ABN, businessName, iframeShown, loading } = this.state
    const formattedABN = this.formatABN(ABN) // e.g. 41 824 753 556
    const srcUrl = `${this.props.baseUrl}/story.html?firstName=${encodeURIComponent(firstName)}&lastName=${encodeURIComponent(lastName)}&ABN=${encodeURIComponent(formattedABN)}&businessName=${encodeURIComponent(businessName)}`

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
      iframeShown
    ?  <div className='container-fluid pt-3'>
          <div dangerouslySetInnerHTML={{ __html: this.state.topTextHtml }} />
          <iframe
            title="Export Readiness"
            style={{ width: '100%', minHeight: '750px' }}
            src={srcUrl}
          >
          </iframe>
      </div>
      : <div>Please wait...</div>
    );

      // eslint-disable-next-line no-unreachable
      return (
          <div>
              <h2>testing only</h2>
              <button type="button" onClick={this.handleButtonClick}>
                  Click me
              </button>
          </div>
      )
  }
}
